import type { ClientAuthorization } from '@/platform/session/sessionSlice'

export function hasPermission(authorization: ClientAuthorization, required: string): boolean {
  if (authorization.permissions.includes('*') || authorization.permissions.includes(required)) return true
  const parts = required.split('.')
  while (parts.length > 1) {
    parts.pop()
    if (authorization.permissions.includes(`${parts.join('.')}.*`)) return true
  }
  return false
}

export function hasAllPermissions(authorization: ClientAuthorization, required: string[]): boolean {
  return required.length === 0 || required.every((permission) => hasPermission(authorization, permission))
}
